import Vue from 'vue'
import authorization from '@/utils/authorization'

function sortByAlarmAt (a, b) {
  if (a.lastAlarmAt && b.lastAlarmAt) return new Date(b.lastAlarmAt) - new Date(a.lastAlarmAt)
  return new Date(b.alarmAt) - new Date(a.alarmAt)
}

const state = {
  issues: []
}
// getters
const getters = {
  all: state => state.issues
}

// actions
const actions = {

  async preloadIssues ({ state, dispatch }) {
    if (!authorization.authorize()) return
    if (state.issues.length > 0) return
    await dispatch('fetchIssues')
  },

  async fetchIssues ({ commit }) {
    const res = await Vue.axios.get('/api/issues/')
    if (res.status === 200) commit('setIssues', res.data.alarms)
  }
}

// mutations
const mutations = {

  setIssues (state, issues) {
    // info field is now used as comments in json, this below we do to be backward compatible
    let parsedAlarms = issues.map(alarm => {
      alarm.comments = []
      if (alarm.info && typeof alarm.info === 'string') {
        if (alarm.info[0] === '{') {
          try {
            let parsedInfo = JSON.parse(alarm.info)
            alarm.comments = (parsedInfo.comments || [])
          } catch (e) {
            // most likely not json, no need to do anything about it now
          }
        } else {
          // convert last info to a comment
          alarm.comments.push({
            by: alarm.infoBy,
            byId: alarm.infoByAccountID,
            at: alarm.infoAt,
            text: alarm.info
          })
        }
      }
      return alarm
    })
    state.issues = parsedAlarms.sort(sortByAlarmAt)
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/issues.js